// extracted by mini-css-extract-plugin
export default {"rating":"AL-z","numberOfStars":"BL-z","count":"CL-z","barGraphSpacing":"DL-z","barGraph":"EL-z"};